import React, { useContext, useEffect } from 'react';
import Sidebar from '../layout/Sidebar';
import Barra from '../layout/Barra';
import FormCritica from '../criticas/';
import ListadoCriticas from '../criticas/ListadoCriticas';
import AuthContext from '../../context/autenticacion/authContext';
import criticaContext from '../../context/criticas/criticaContext';
/* import proyectoContext from '../../context/proyectos/proyectoContext'; */


const Proyectos = () => {

    // Extraer la información de autenticación
    const authContext = useContext(AuthContext);
    const { usuarioAutenticado } = authContext;

    // obtener la función del context de critica
    const criticasContext = useContext(criticaContext);
    const { estadoformulario } = criticasContext;

    /* // Extrar si un proyecto esta activo
    const proyectosContext = useContext(proyectoContext);
    const { proyecto } = proyectosContext; */


    useEffect(() => {
        usuarioAutenticado();
        // eslint-disable-next-line
    }, [])

   

    return ( 
        <div className="contenedor-app">
            <Sidebar />

            <div className="seccion-principal">
                <Barra />

                <main>
                   
                    
                    <div className="contenedor-tareas"> 
                    { estadoformulario ? <FormCritica /> : null }
                        <ListadoCriticas /> 
                    </div> 
                </main>
            </div>
        </div>
     );
}
 
export default Proyectos;